import React from "react";

import Button from "@SonarCX/components/atoms/Button2";
import NoPermissionContainer from "@SonarCX/components/molecules/NoPermissionContainer";
import { useAppSelector } from "@SonarCX/hooks/redux";
import useAccess, { PERMS } from "@SonarCX/hooks/useAccess";
import { useSupabase } from "@SonarCX/providers/SupabaseProvider";
import { selectCategory } from "@SonarCX/slices/category";
import { selectTaskType } from "@SonarCX/slices/taskType";
import SettingsSection from "../../SettingsSection";
import CategoryRule from "./CategoryRule";
import CategoryRulesSettingsModal from "./CategoryRulesSettingsModal";
import useStyles from "./styles";

const CategoryRulesSettings: React.FC = () => {
  const { loaded: categoryLoaded, error: categoryError } =
    useAppSelector(selectCategory);
  const { loaded: taskTypeLoaded, error: taskTypeError } =
    useAppSelector(selectTaskType);
  const hasPermission = useAccess();
  const {
    taskCategoryRules: { rules, upsertRule },
  } = useSupabase();

  const [adding, setAdding] = React.useState(false);
  const [editing, setEditing] = React.useState(null);

  const classes = useStyles();

  return (
    <NoPermissionContainer skipAgentPage error={categoryError || taskTypeError}>
      <SettingsSection
        title="Category Rules"
        loaded={categoryLoaded && taskTypeLoaded}
      >
        <div className={classes.rulesContainer}>
          {rules.length === 0 && <div>No category rules defined.</div>}

          {rules.map((rule) => (
            <CategoryRule
              key={rule.id}
              rule={rule}
              onClickEdit={() => setEditing(rule)}
            />
          ))}
        </div>

        {hasPermission([PERMS.TasksAdmin]) && (
          <Button onClick={() => setAdding(true)} className={classes.addButton}>
            ADD
          </Button>
        )}
      </SettingsSection>

      {adding && (
        <CategoryRulesSettingsModal
          onClose={() => setAdding(false)}
          onSubmit={async (categoryId, types) => {
            await upsertRule({ categoryId, types });
          }}
        />
      )}

      {editing && (
        <CategoryRulesSettingsModal
          values={editing}
          onClose={() => setEditing(null)}
          onSubmit={async (categoryId, types) => {
            await upsertRule({ id: editing.id, categoryId, types });
          }}
        />
      )}
    </NoPermissionContainer>
  );
};

export default CategoryRulesSettings;
